import { post } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

const requestSchema = z.object({
  facilityId: z.string(),
});

const responseSchema = z.object({
  countOfNegotiationsClosed: z.number(),
});

interface UseCloseOpenNegotiationsParams {
  facilityId: string;
}

// Matches APP_V2_APP_EVENTS pattern — cannot import from @src/constants/ in appV2
const CLOSE_OPEN_NEGOTIATIONS_FAILURE = "Settings Redesign: Close Open Negotiations Failure";

export function useCloseOpenNegotiations() {
  return useMutation({
    mutationFn: async (parameters: UseCloseOpenNegotiationsParams) => {
      const response = await post({
        url: `${environmentConfig.REACT_APP_API_MAIN_URL}/api/negotiation/facilityCloseNegotiations`,
        data: { facilityId: parameters.facilityId },
        bodySchema: requestSchema,
        responseSchema,
      });

      return response.data;
    },
    meta: { logErrorMessage: CLOSE_OPEN_NEGOTIATIONS_FAILURE },
  });
}
